// hybrid component is in this path
import { HOME } from '@/constants';
import { BrandIcon } from './brandIcon';
import { LinkButton, LinkButtonProps } from '../LinkBtn/LinkBtn';
import { BrandAltIcon } from './brandIconAlt';
import { BrandIconV2 } from './brandIconV2';

interface BrandButtonProps {
  className?: string;
  size?: LinkButtonProps['size'];
  alt?: boolean;
  disabled?: boolean;
}

/**
 * BrandButton now inherits from LinkButton to provide semantic
 * anchor-based navigation to the home route while retaining
 * the primary button branding and active state scaling.
 */
export const BrandButton = ({
  className = '',
  size = 'md',
  alt = false,
  disabled = false,
  ...props
}: BrandButtonProps) => {
  return (
    <LinkButton
      href={HOME}
      variant="ghost"
      size={size}
      className={`rounded-full shrink-0 h-full hover:bg-transparent! ${className}`}
      aria-label="Home"
      disabled={!disabled}
      {...props}
    >
      {alt ? <BrandIconV2 variant="dark" /> : <BrandIconV2 variant="light" />}
    </LinkButton>
  );
};
